import * as Sentry from "@sentry/nextjs"

import useToast from "@hooks/useToast"
import { ActivityDetailsFormAttributes } from "@modules/tenants/OrdersPage/ViewOrderPage/Components/ActivityRescheduleModal/ActivityDetailsForm"
import { useRebookMutation } from "@mono/essentials/entities/booking/hooks"
import { useUpdateQuantityOfOrderItemMutation } from "@mono/essentials/entities/order/hooks"
import { GetOrderDetailsResponseType } from "@mono/essentials/types/OrderTypes"

export const useHandleRescheduleActivityBooking = () => {
  const { showToast } = useToast()
  const { mutateAsync: updateQuantityOfOrderItemMutation } = useUpdateQuantityOfOrderItemMutation()
  const { mutateAsync: rebookMutation } = useRebookMutation()

  const handleRescheduleActivityBooking = async ({
    productInfo,
    orderItemId,
    onSuccess,
    onError,
    orderData,
    shouldUpdateQuantity = false,
  }: {
    productInfo: ActivityDetailsFormAttributes
    orderItemId: string
    onSuccess?: () => Promise<void>
    onError?: (error: any) => Promise<void>
    orderData?: GetOrderDetailsResponseType
    shouldUpdateQuantity?: boolean
  }) => {
    try {
      if (productInfo && orderData?.id && orderItemId) {
        const selectedOrderItem = orderData.items.find((oi) => oi.id === orderItemId)
        if (
          selectedOrderItem?.booking?.id &&
          selectedOrderItem.slot_id !== (productInfo?.time?.value ?? productInfo?.time)
        ) {
          await rebookMutation({
            bookingId: selectedOrderItem.booking.id,
            body: {
              slot_id: productInfo?.time?.value ?? productInfo?.time,
            },
            filter: {
              is_overusing_resources_checked: productInfo?.is_overusing_resources_checked ?? false,
            },
          })
        }

        if (shouldUpdateQuantity) {
          const newQuantities = productInfo?.units?.filter((unitInfo) => unitInfo.unitCount > 0)
          await updateQuantityOfOrderItemMutation({
            orderId: orderData.id,
            orderItemId,
            payload: {
              quantities: newQuantities.map((unit) => ({
                unit_id: unit.unitId ?? "",
                quantity: unit.unitCount ?? 1,
                booking_id: selectedOrderItem?.booking?.id,
              })),
            },
          })
        }

        await onSuccess?.()
      } else {
        showToast({
          heading: "Unable to reschedule! please try again later.",
          type: "danger",
        })
      }
    } catch (error) {
      Sentry.captureException(error)
      await onError?.(error)
    }
  }

  return { handleRescheduleActivityBooking }
}
